// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__IZ1Rk","icon":"styles_icon__S3g3L","title":"styles_title__Fz9ZM","description":"styles_description__sIQoK"};